import { Component, Input, OnInit } from '@angular/core';
import {
  NgbActiveModal,
  NgbModal
} from '@ng-bootstrap/ng-bootstrap';
import {
  UntypedFormControl,
  Validators,
  UntypedFormGroup,
  UntypedFormBuilder,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule, formatDate } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import Swal from 'sweetalert2';
import { RestClientService } from '@core/service/rest-client.service';
import { UtilitiesService } from '@core/service/utilities.service';
import { ErrorMessageService } from '@core/service/error-message.service';
import { AuthService } from '@core';
import { Direction } from '@angular/cdk/bidi';
import { FormDialogComponent as ModalAddClient } from '../../../administration/utilisateur-client/form-dialog/form-dialog.component';
import { FormDialogComponent as ModalAddApporteur } from '../../../administration/utilisateur-apporteur/form-dialog/form-dialog.component';
import moment from 'moment';
import { IntegerFormatPipe } from '@core/pipe/integer-format.pipe';
import {
  BsDatepickerConfig,
  BsDatepickerModule,
} from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { frLocale } from 'ngx-bootstrap/locale';
import { ShoppingArticleComponent } from '@shared/shopping-article/shopping-article.component';
import { ShoppingFoodComponent } from '@shared/shopping-food/shopping-food.component';
import { PreviewPdfComponent } from 'app/preview-pdf/preview-pdf.component';
import { PrintService } from '@core/service/print.service';
import { FormDialogComponent } from 'app/administration/client/form-dialog/form-dialog.component';
import { ClientSearchSelectComponent } from '@shared/components/client-search-select/client-search-select.component';
import { ApporteurSearchSelectComponent } from '@shared/components/apporteur-search-select/apporteur-search-select.component';
export interface DialogData {
  id: number;
  action: string;
  item: any;
  type_service_codification: any;
}

defineLocale('fr', frLocale);

import { MontantInputDirective } from '@shared/directive/montant-input.directive';

@Component({
  selector: 'app-modal-hebergement-direct',
  imports: [
    MontantInputDirective,
    CommonModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    IntegerFormatPipe,
    BsDatepickerModule,
    ShoppingFoodComponent,
    ShoppingArticleComponent,
    ClientSearchSelectComponent,
    ApporteurSearchSelectComponent,
  ],
  templateUrl: './modal-hebergement-direct.component.html',
  styleUrl: './modal-hebergement-direct.component.scss',
})
export class ModalHebergementDirectComponent implements OnInit {
  @Input() data: any = {};
  /** Chambre choisie depuis le planning : retenue si elle figure parmi les chambres libres. */
  private chambreProposee?: number;
  action: string = '';
  dialogTitle: string = '';
  // bookingForm: UntypedFormGroup;
  // booking: Article;
  client_search_key: any;
  apporteur_search_key: any;
  itemToSave: any = {};
  itemsNationnalite: any = [
    {
      user_nationnalite_name: 'IVOIRIENNE',
      user_nationnalite_id: 'IVOIRIENNE',
    },
    { user_nationnalite_name: 'BURKINABE', user_nationnalite_id: 'BURKINABE' },
    {
      user_nationnalite_name: 'SENEGALAIS',
      user_nationnalite_id: 'SENEGALAIS',
    },
  ];
  itemsNaturePiece: any = [
    {
      nature_piece_name: 'CARTE_IDENTITE',
      user_nature_of_piece: 'CARTE_IDENTITE',
    },
    { nature_piece_name: 'PASSEPORT', user_nature_of_piece: 'PASSEPORT' },
    {
      nature_piece_name: 'PERMIS_CONDUIRE',
      user_nature_of_piece: 'PERMIS_CONDUIRE',
    },
  ];
  createMessage = '';
  editMessage = '';
  deleteMessage = '';
  gender = 'M';
  entity = 'booking';
  isLoading: boolean = false;
  itemsRoom: any;
  endPoint: string = 'hebergement';
  title = 'hébergement direct';

  itemClient: any = {};
  user: any = {};
  hasBoutique: boolean = false;
  itemsReservation: any = [];

  itemsService: any = [];
  itemsChambre: any = [];
  itemsClient: any = [];
  itemsApporteur: any = [];

  imageDisplay: any;
  imageName: string | undefined;
  currentItemImage:
    | {
        fileBase64: any;
        fileName: any;
        extension: any;
        typeDocument: string;
      }
    | undefined;
  loading: boolean | undefined;
  itemsModeReglement: any = [];
  itemsUserCaisse: any;
  clientFidelite: any = null;
  showTimeFiels: boolean = false;
  duree_jours: any = 0;
  duree_heures: any = 0;
  itemsTypeReservation: any = [];
  itemsTypeHebergement: any = [];
  current_service: any = {};

  myDate!: Date;
  minDate!: Date;
  maxDate!: Date;
  datePickerConfig?: Partial<BsDatepickerConfig>;
  indice: number = 0;
  itemsFileAttenteHebergement: any;
  date_debut: Date;
  date_fin: Date;
  queueCount: any = 0;

  // ─── Vente directe boutique ───────────────────────────────────────────────
  venteDirecteEnabled = false;
  itemsCommandeDetailToSave: any[] = [];
  article_search = '';
  itemsArticle: any[] = [];
  venteDirecteTypeCommandeId: any = null;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: UntypedFormBuilder,
    private restClient: RestClientService,
    private utilities: UtilitiesService,
    private errorMessage: ErrorMessageService,
    private authService: AuthService,
    private modalService: NgbModal,
    public printService: PrintService
  ) {
    this.user = this.authService.getCurrentUser();
    this.hasBoutique = this.authService.hasBoutique();
    let text1 = this.gender == 'M' ? 'un' : 'une';
    this.createMessage =
      'Vous êtes sur le point de créer ' + text1 + ' ' + this.title;
    this.editMessage =
      'Vous êtes sur le point de modifier ' + text1 + ' ' + this.title;
    this.deleteMessage =
      'Vous êtes sur le point de supprimer ' + text1 + ' ' + this.title;

    const today = new Date();
    this.myDate = new Date();
    this.minDate = today;
    const future = new Date();
    future.setDate(future.getDate() + 30);
    this.maxDate = future;
    this.datePickerConfig = {
      minDate: this.minDate,
      maxDate: this.maxDate,
      keepDatesOutOfRules: true,
      dateInputFormat: 'DD/MM/YYYY',
    };

    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    this.date_debut = yesterday;
    this.date_fin = tomorrow;
  }

  ngOnInit() {
    this.action = this.data?.action;
    console.log('data: ', this.data);
    if (this.action === 'edit') {
      this.dialogTitle = '';
      this.itemToSave = { ...(this.data?.item || {}) };
      console.log('this.itemToSave: ', this.itemToSave);
      if (this.data.item?.image_url) {
        this.imageDisplay = this.data.item?.image_url;
      }
      // this.onSearchClient(this.itemToSave.client_id);
      this.getItemsService();
      this.getitemsChambre();
    } else {
      this.dialogTitle = ' ';
      this.itemToSave = {};
      this.itemToSave.type_service_codification =
        this.data.type_service_codification;
      this.chambreProposee = this.data?.chambre_id;
    }
    this.itemToSave.montant_recu = 0;
    this.itemToSave.monnaie_rendue = 0;
    this.getItemsReservation();
    this.getItemsModeReglement();
    this.getitemsUserCaisse();
    this.getitemsChambre();
    this.getItemsService();
    this.getItemsTypeHebergement();
    this.getitemsFileAttente();
    this.getItemsClient();
    this.getItemsArticle();
    this.getItemsTypeCommandeBoutique();
  }

  submit() {}

  onSelectReservation() {
    console.log('this.itemsReservation: ', this.itemsReservation);
    console.log(
      'this.itemToSave.reservation_id: ',
      this.itemToSave.reservation_id
    );
    let current_reservation = this.itemsReservation.find(
      (ir: any) => ir.id == this.itemToSave.reservation_id
    );
    this.itemToSave.chambre_id = current_reservation.chambre_id;
    this.itemToSave.date_debut = current_reservation.date_debut;
    this.itemToSave.date_fin = current_reservation.date_fin;
    this.itemToSave.heure_debut = current_reservation.heure_debut;
    this.itemToSave.heure_fin = current_reservation.heure_fin;
    this.itemToSave.montant_total = current_reservation.montant_total;
    this.itemToSave.montant_avance = 0;
    this.itemToSave.total_regle = current_reservation.total_regle;
    this.itemToSave.reste_a_regler = current_reservation.reste_a_regler;
    this.itemToSave.total_ristourne = current_reservation.total_ristourne;
    this.itemToSave.client_id = current_reservation.client_id;
    this.itemToSave.date_debut = current_reservation.date_debut;
    this.itemToSave.date_fin = current_reservation.date_fin;
    this.itemToSave.service_id = current_reservation.service_id;
    // this.onSearchClient(this.itemToSave.client_id);
    this.getItemsClient();
    console.log('itemtosave: ', this.itemToSave);
  }

  confirmSaveItem(item: any) {
    if (!this.itemToSave.client_id) {
      this.utilities.showNotification(
        'snackbar-danger',
        'Veuillez renseigner client svp',
        'bottom',
        'center'
      );
      return;
    }
    if (
      this.current_service.codification &&
      this.current_service.codification == 'PASS'
    ) {
      if (
        !this.itemToSave.montant_ristourne_file_attente &&
        (!this.itemToSave.montant_recu ||
          this.itemToSave.montant_recu < this.itemToSave.montant_total)
      ) {
        this.utilities.showNotification(
          'snackbar-danger',
          'Veuillez reclamer la totalité en cas de passage svp!',
          'bottom',
          'center'
        );
        return;
      }
    } else {
      if (
        this.itemToSave.montant_avance &&
        this.itemToSave.montant_avance > this.itemToSave.montant_total
      ) {
        this.utilities.showNotification(
          'snackbar-danger',
          'Le montant avance ne peut etre supérieur au montant total!',
          'bottom',
          'center'
        );
        return;
      }

      if (
        !this.itemToSave.montant_avance ||
        !this.itemToSave.montant_recu ||
        this.itemToSave.montant_recu < this.itemToSave.montant_avance
      ) {
        this.utilities.showNotification(
          'snackbar-danger',
          "Le montant reçu ne peut etre inférieur à l'avance!",
          'bottom',
          'center'
        );
        return;
      }
    }

    // if (!this.itemToSave.montant_avance || !(this.itemToSave.montant_avance > 0)) {
    //   this.utilities.showNotification(
    //     "snackbar-danger",
    //     "Veuillez reclamer la totalité ou une avance svp!",
    //     "bottom",
    //     "center"
    //   );
    //   return
    // }

    if (!item.id) item.code = this.generateUniqueString();
    let objToSave = Object.assign({}, item);
    Swal.fire({
      title: this.capitalize(this.title),
      text: objToSave?.id ? this.editMessage : this.createMessage,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0665aa',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
    }).then((result) => {
      if (result.value) {
        // objToSave.code = objToSave.code.trim().toUpperCase();
        this.saveItem(objToSave);
      }
    });
  }
  onControlAvanceField() {
    if (
      (this.current_service &&
        this.current_service.codification == 'PASS' &&
        !this.itemToSave.montant_avance) ||
      this.itemToSave.montant_avance < this.itemToSave.montant_total
    ) {
      this.utilities.showNotification(
        'snackbar-danger',
        'Veuillez reclamer la totalité en cas de passage svp!',
        'bottom',
        'center'
      );
      return;
    }

    if (
      !this.itemToSave.montant_avance ||
      !(this.itemToSave.montant_avance > 0)
    ) {
      this.utilities.showNotification(
        'snackbar-danger',
        'Veuillez reclamer la totalité ou une avance svp!',
        'bottom',
        'center'
      );
      return;
    }
  }

  saveItem(item: any) {
    console.info('item to save', item);

    this.isLoading = true;

    let itemAEnregistrer = Object.assign({}, item);

    if (this.currentItemImage && Object.keys(this.currentItemImage).length) {
      itemAEnregistrer.file_data = this.currentItemImage;
    } else {
      delete itemAEnregistrer.file_data;
    }

    let reduce = [];

    itemAEnregistrer.groupe_id = this.user.groupe_id;
    itemAEnregistrer.hotel_id = this.user.hotel_id;

    itemAEnregistrer.duree_jours = this.duree_jours;
    itemAEnregistrer.duree_heures = this.duree_heures;
    itemAEnregistrer.is_ristourne = false;
    itemAEnregistrer.is_validated = true;
    itemAEnregistrer.is_cancelled = false;
    itemAEnregistrer.is_sortie = false;
    itemAEnregistrer.is_clotured = false;
    itemAEnregistrer.type_hebergement_id = this.itemsTypeHebergement.find(
      (itr: any) => itr.codification == 'CHAMBRE'
    )?.id;

    var request = {
      datas: [itemAEnregistrer],
    };

    this.restClient
      .post(
        this.endPoint + '' + (itemAEnregistrer.id ? '/update' : '/create'),
        request
      )
      .subscribe(
        (res: any) => {
          console.info('resul', res);
          this.isLoading = false;

          if (!res['hasError']) {
            this.utilities.showNotification(
              'snackbar-success',
              this.utilities.formatMsgServeur(res['status']['message']),
              'bottom',
              'center'
            );
            const createdHebergement = res['item'];

            const finalize = () => {
              this.activeModal.close(createdHebergement);
              if (
                this.itemToSave.montant_avance &&
                this.itemToSave.montant_avance > 0
              ) {
                this.getItemsReglementHebergement(createdHebergement);
              }
            };

            console.log(
              '[VenteDirecte] items in cart:',
              this.itemsCommandeDetailToSave.length
            );
            console.log('[VenteDirecte] hebergement créé:', createdHebergement);
            if (this.itemsCommandeDetailToSave.length > 0) {
              console.log(
                '[VenteDirecte] → lancement saveVenteDirecteCommande'
              );
              this.saveVenteDirecteCommande(createdHebergement, finalize);
            } else {
              console.log(
                '[VenteDirecte] → panier vide, pas de commande boutique'
              );
              finalize();
            }
          } else {
            if (res['status'] && res['status']['message']) {
              this.utilities.showNotification(
                'snackbar-danger',
                this.utilities.formatMsgServeur(res['status']['message']),
                'bottom',
                'center'
              );
            }
          }
        },
        (err) => {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.getMessageEndPointNotAvailble(),
            'bottom',
            'center'
          );
          this.loading = false;
        }
      );
  }

  getItemsReglementHebergement(item: any) {
    this.itemsChambre = [];
    let request = {
      data: {
        hebergement_id: item.hebergement_id,
      },
      index: 0,
      size: 10000,
    };

    this.restClient
      .post('reglementHebergement/getByCriteria', request)
      .subscribe(
        (res: any) => {
          if (res && res['items'] && !res['hasError']) {
            this.imprimerReglement(res.items[0]);
          } else {
            this.utilities.showNotification(
              'snackbar-danger',
              this.utilities.formatMsgServeur(res['status']['message']),
              'bottom',
              'center'
            );
          }
        },
        (err) => {}
      );
  }

  imprimerReglement(item: any) {
    let request = {
      data: {
        // telephone:this.client_search_key
        id: item.id,
      },
      index: 0,
      size: 10000,
    };

    this.restClient.post('pdf/printRecuHebergement', request).subscribe(
      (res: any) => {
        if (res && res['item'] && !res['hasError']) {
          window.open(res['item'].link, '_blank');
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center'
          );
        }
      },
      (err) => {}
    );
  }

  getItemsReservation() {
    this.itemsChambre = [];
    let request = {
      type_reservation_codification: 'CHAMBRE',
      data: {},
      index: 0,
      size: 10000,
    };

    this.restClient.post('reservation/getByCriteria', request).subscribe(
      (res: any) => {
        if (res && res['items'] && !res['hasError']) {
          this.itemsReservation = res['items'];
          this.itemsReservation = this.itemsReservation.filter(
            (ir: any) =>
              ir.statut_code !== 'HEBERGEMENT' &&
              ir.statut_code !== 'ANNULE' &&
              ir.statut_code !== 'SORTIE' &&
              !ir.is_bloquee &&
              !ir.is_confirmee &&
              ir.can_be_hebergement
          );
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center'
          );
          this.itemsReservation = [];
        }
      },
      (err) => {
        this.itemsReservation = [];
      }
    );
  }
  getItemsModeReglement() {
    // this.itemsChambre = []
    let request = {
      data: {},
      index: 0,
      size: 10000,
    };

    this.restClient.post('modeReglement/getByCriteria', request).subscribe(
      (res: any) => {
        if (res && res['items'] && !res['hasError']) {
          this.itemsModeReglement = res['items'];
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center'
          );
          this.itemsModeReglement = [];
        }
      },
      (err) => {
        this.itemsModeReglement = [];
      }
    );
  }

  uploadFile(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      const fileName = file.name.split('.')[0];
      const Tabextension = file.name.split('.');
      const extension = Tabextension[Tabextension.length - 1];

      console.info('fileName', fileName);
      console.info('extension', extension);
      this.imageName = fileName + '.' + extension;
      reader.onload = (readerEvent) => {
        const data = (readerEvent.target as any).result;
        this.imageDisplay = data;
        const fileBase64 = data.split(',')[1];
        this.currentItemImage = {
          fileBase64: fileBase64,
          fileName: fileName,
          extension: extension,
          typeDocument: 'custom type',
        };
      };
    }

    reader.readAsDataURL(event.target.files[0]);
  }

  getitemsChambre() {
    // debugger
    console.log('calling getitemsChambre() ');
    this.itemsChambre = [];
    // if(this.current_service.codification == 'PASS'){

    // }
    // if (!this.itemToSave.id && !this.itemToSave.service_id || !this.itemToSave.date_debut || !this.itemToSave.date_fin) return
    console.log('this.itemToSave.service_id: ', this.itemToSave.service_id);
    console.log('this.itemToSave.date_debut: ', this.itemToSave.date_debut);
    console.log('this.itemToSave.date_fin: ', this.itemToSave.date_fin);
    if (
      !this.itemToSave.service_id ||
      !this.itemToSave.date_debut ||
      !this.itemToSave.date_fin
    )
      return;
    console.log('1');

    let request: any = {
      data: {},
      index: 0,
      size: 10000,
    };

    if (!this.itemToSave.id) {
      request.chambre_status = 'AVAILABLE'; // POUR RECUPER UNIQUEMENT LES CHAMBRES DISPONIBLES
      request.service_id = this.itemToSave.service_id;
      // request.date_debut = this.itemToSave.date_debut
      // request.date_fin = this.itemToSave.date_fin
      request.debut_reservation = this.itemToSave.date_debut;
      request.fin_reservation = this.itemToSave.date_fin;
      // PASS sans nombre d'heures : disponibilités sur 1h, rafraîchies à la saisie de la durée
      if (
        this.current_service?.codification == 'PASS' &&
        !(this.itemToSave.duree_heures > 0)
      ) {
        request.fin_reservation = moment(this.itemToSave.date_debut)
          .add(1, 'hours')
          .toDate();
      }
    }
    this.restClient.post('chambre/getByCriteria', request).subscribe(
      (res: any) => {
        if (res && res['items'] && !res['hasError']) {
          this.itemsChambre = res['items'];
          if (this.chambreProposee && !this.itemToSave.chambre_id
            && this.itemsChambre.some((chambre: any) => chambre.id == this.chambreProposee)) {
            this.itemToSave.chambre_id = this.chambreProposee;
            this.calculatePrice();
          }
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center'
          );
          this.itemsChambre = [];
        }
      },
      (err) => {
        this.itemsChambre = [];
      }
    );
  }

  getitemsUserCaisse() {
    let request = {
      add_solde_info: true,
      add_caisse_status: true,
      data: {
        user_id: this.user.id,
        hotel_id: this.user.hotel_id,
      },
      index: 0,
      size: 10000,
    };

    this.restClient.post('userCaisse/getByCriteria', request).subscribe(
      (res: any) => {
        if (res && res['items'] && !res['hasError']) {
          this.itemsUserCaisse = res['items'];
          this.itemsUserCaisse = this.itemsUserCaisse.filter(
            (ic: any) => ic.is_open
          );
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center'
          );
          this.itemsUserCaisse = [];
        }
      },
      (err) => {
        this.itemsUserCaisse = [];
      }
    );
  }

  getItemsClient() {
    // if(!this.client_search_key) return
    let request = {
      data: {
        // telephone:this.client_search_key
        hotel_id: this.itemToSave.client_id,
      },
      index: 0,
      size: 10000,
    };

    this.restClient.post('client/getByCriteria', request).subscribe(
      (res: any) => {
        if (res && res['items'] && !res['hasError']) {
          this.itemsClient = res['items'];
          // if (client_id) this.itemToSave.client_id = client_id;
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center'
          );
          this.itemsClient = [];
        }
      },
      (err) => {
        this.itemsClient = [];
      }
    );
  }
  onGetChambreDisponible() {
    // Conserver la chambre choisie si elle reste disponible pour les nouveaux horaires
    this.chambreProposee = this.itemToSave.chambre_id || this.chambreProposee;
    this.itemToSave.chambre_id = null;
    this.getitemsChambre();
  }

  onResetHours() {
    this.itemToSave.date_debut = moment();
    this.itemToSave.date_fin = moment();
    this.itemToSave.heure_debut = moment().format('HH:mm');
    this.itemToSave.heure_fin = moment().format('HH:mm');
    this.itemToSave.duree_heures = 0;
  }

  onSelectService() {
    // this.resetFields()

    // debugger
    this.current_service =
      this.itemsService.find(
        (is: any) => is.id == this.itemToSave.service_id
      ) || {};
    console.log('this.current_service: ', this.current_service);
    if (this.current_service != 'SEJOUR') {
      // debugger
      // this.itemToSave.date_debut=moment()
      // this.itemToSave.date_fin=moment()
      if (
        this.current_service.codification == 'JOURNEE' ||
        this.current_service.codification == 'NUIT'
      ) {
        this.itemToSave.heure_debut =
          this.current_service.periodicite_heure_debut;
        this.itemToSave.heure_fin = this.current_service.periodicite_heure_fin;

        if (this.current_service.codification === 'JOURNEE') {
          // Base date: tomorrow at 00:00
          const baseDate = moment().startOf('day');

          // Parse and apply start time
          const [heureDebut, minuteDebut] = this.itemToSave.heure_debut
            .split(':')
            .map(Number);
          this.itemToSave.date_debut = baseDate
            .clone()
            .add(heureDebut, 'hours')
            .add(minuteDebut, 'minutes');

          // Parse and apply end time
          const [heureFin, minuteFin] = this.itemToSave.heure_fin
            .split(':')
            .map(Number);
          this.itemToSave.date_fin = baseDate
            .clone()
            .add(heureFin, 'hours')
            .add(minuteFin, 'minutes');
        }
        if (this.current_service.codification === 'NUIT') {
          // Base date: tomorrow at 00:00
          const baseDateDebut = moment().startOf('day');
          const baseDateFin = moment().add(1, 'days').startOf('day');

          // Parse and apply start time
          const [heureDebut, minuteDebut] = this.itemToSave.heure_debut
            .split(':')
            .map(Number);
          this.itemToSave.date_debut = baseDateDebut
            .clone()
            .add(heureDebut, 'hours')
            .add(minuteDebut, 'minutes');

          // Parse and apply end time
          const [heureFin, minuteFin] = this.itemToSave.heure_fin
            .split(':')
            .map(Number);
          this.itemToSave.date_fin = baseDateFin
            .clone()
            .add(heureFin, 'hours')
            .add(minuteFin, 'minutes');
        }
        // this.itemToSave.date_fin=moment()
      }
      if (this.current_service.codification == 'PASS') {
        this.itemToSave.date_debut = this.itemToSave.date_debut ?? moment();
        this.itemToSave.date_fin = this.itemToSave.date_fin ?? moment();
      }
      if (this.current_service.codification == 'SEJOUR') {
        this.itemToSave.date_debut = this.itemToSave.date_debut ?? moment();
        this.itemToSave.date_fin = moment(this.itemToSave.date_debut).add(
          1,
          'days'
        );
      }
    }

    if (moment.isMoment(this.itemToSave.date_debut)) {
      this.itemToSave.date_debut = this.itemToSave.date_debut.toDate();
    }
    if (moment.isMoment(this.itemToSave.date_fin)) {
      this.itemToSave.date_fin = this.itemToSave.date_fin.toDate();
    }
    this.onGetChambreDisponible();
  }

  resetFields() {
    this.itemToSave.chambre_id = null;
    // this.itemToSave.client_id=null
    this.itemToSave.montant_total = null;
    // this.itemToSave.heure_debut=null
    // this.itemToSave.heure_fin=null
    // this.itemToSave.date_debut_reservation=null
    // this.itemToSave.date_fin_reservation=null
    // this.itemToSave.duree_heures=null
  }

  onSetDateTimeBasedOnDuration() {
    // debugger
    if (this.current_service.codification == 'PASS') {
      this.itemToSave.montant_total = 0;
      this.itemToSave.montant_avance = 0;
      this.itemToSave.date_debut = moment();
      if (this.itemToSave.duree_heures && this.itemToSave.duree_heures > 0) {
        if (this.itemToSave.heure_debut) {
          // this.itemToSave.heure_debut = moment().format('HH:mm');
          this.itemToSave.heure_fin = moment(
            this.itemToSave.heure_debut,
            'HH:mm'
          )
            .add(this.itemToSave.duree_heures, 'hours')
            .format('HH:mm');
          console.log('this.itemToSave.heure_fin: ', this.itemToSave.heure_fin);
          const [hour, minute] = this.itemToSave.heure_fin
            .split(':')
            .map(Number);
          this.itemToSave.date_fin = moment()
            .startOf('day')
            .add(hour, 'hours')
            .add(minute, 'minutes');
        } else {
          this.itemToSave.heure_debut = moment().format('HH:mm');
          this.itemToSave.heure_fin = moment()
            .add(Number(this.itemToSave.duree_heures), 'hours')
            .format('HH:mm');
        }
        console.log('this.itemToSave.date_fin: ', this.itemToSave.date_fin);
      }
      this.itemToSave.date_fin = moment().add(
        Number(this.itemToSave.duree_heures),
        'hours'
      );
      this.onGetChambreDisponible();
    }
    this.onGetChambreDisponible();
  }
  // onSetDurationBasedOnTime(){
  //   if (this.current_service.codification == 'PASS' && this.itemToSave.heure_debut && this.itemToSave.heure_fin) {
  //     const start = moment(this.itemToSave.date_debut, 'HH:mm');
  //     const end = moment(this.itemToSave.date_fin, 'HH:mm');

  //     const diffHours = end.diff(start, 'hours'); // difference in full hours
  //     console.log(diffHours);
  //     this.itemToSave.duree_heures = diffHours

  //     const baseDateDebut = moment(this.itemToSave.date_debut).startOf('day');
  //     const [heureDebut, minuteDebut] = this.itemToSave.heure_debut.split(':').map(Number);
  //     this.itemToSave.date_debut = baseDateDebut.clone().add(heureDebut, 'hours').add(minuteDebut, 'minutes');

  //     // Parse and apply end time
  //     const baseDateFin = moment(this.itemToSave.date_fin).startOf('day');
  //     const [heureFin, minuteFin] = this.itemToSave.heure_fin.split(':').map(Number);
  //     this.itemToSave.date_fin = baseDateFin.clone().add(heureFin, 'hours').add(minuteFin, 'minutes');

  //   }
  //    this.onGetChambreDisponible()
  // }

  onSetDurationBasedOnTime() {
    // debugger
    // this.itemToSave.heure_fin=moment()
    // this.itemToSave.duree_heures=0
    if (this.itemToSave.heure_debut) {
      const [hour, minute] = this.itemToSave.heure_debut.split(':').map(Number);
      this.itemToSave.date_debut = moment()
        .startOf('day')
        .add(hour, 'hours')
        .add(minute, 'minutes');

      this.itemToSave.date_fin = moment(this.itemToSave.date_debut).add(
        this.itemToSave.duree_heures,
        'hours'
      );
      // .add(minute, 'minutes')

      // .format('YYYY-MM-DD HH:mm:ss'); // ✅ optional formatting
      console.log('date_debut: ', this.itemToSave.date_debut);
      console.log('date_fin: ', this.itemToSave.date_fin);
      this.itemToSave.heure_fin = moment(this.itemToSave.date_fin).format(
        'HH:mm'
      );
    }

    this.onGetChambreDisponible();
  }

  calculatePrice() {
    // debugger
    if (this.itemToSave.chambre_id) {
      const selected_chambre = this.itemsChambre.find(
        (ic: any) => ic.id == this.itemToSave.chambre_id
      );
      if (this.current_service.codification == 'SEJOUR') {
        const dateDebut = moment(this.itemToSave.date_debut);
        const dateFin = moment(this.itemToSave.date_fin);
        const jours = dateFin.diff(dateDebut, 'days');
        this.duree_jours = jours;
        this.itemToSave.montant_total =
          this.duree_jours * selected_chambre.montant_service;
      } else if (
        this.current_service.codification == 'PASS' &&
        this.itemToSave.duree_heures
      ) {
        this.itemToSave.montant_total =
          this.itemToSave.duree_heures * selected_chambre.montant_service;
        this.itemToSave.montant_avance = this.itemToSave.montant_total;
        // this.onCalculateMonnaie()
      } else {
        this.itemToSave.montant_total = selected_chambre.montant_service;
        // this.duree_heures = 10
      }
    }
  }

  onSetHeure() {
    const selected_service = this.itemsReservation.find(
      (is: any) => is.id === this.itemToSave.service_id
    );

    this.showTimeFiels = false;

    if (
      selected_service?.periodicite_heure_debut &&
      selected_service?.periodicite_heure_fin
    ) {
      this.showTimeFiels = true;

      this.itemToSave.heure_debut = selected_service.periodicite_heure_debut;
      this.itemToSave.heure_fin = selected_service.periodicite_heure_fin;

      if (this.itemToSave.date_debut && this.itemToSave.heure_debut) {
        const t = moment(this.itemToSave.heure_debut, 'HH:mm');

        // Make sure debut_reservation is a moment object
        let debutMoment = moment(this.itemToSave.date_debut);

        if (t.isValid() && t.format('HH:mm') === '20:00') {
          // Add 1 day
          debutMoment.add(1, 'days');
        }
        // Set fin_reservation
        this.itemToSave.date_fin = debutMoment.toDate();
      }
    }
    this.onGetChambreDisponible();
  }

  previewPdf(fileUrl: any) {
    let varDirection: Direction;
    if (localStorage.getItem('isRtl') === 'true') {
      varDirection = 'rtl';
    } else {
      varDirection = 'ltr';
    }
    const modalRef = this.modalService.open(PreviewPdfComponent, {
      size: 'xl',
      windowClass: 'modal-xxl',
      centered: true,
    });
    modalRef.componentInstance.data = { fileUrl: fileUrl };
  }

  openAddClientModal(action: 'add' | 'edit', data?: any) {
    let varDirection: Direction;
    if (localStorage.getItem('isRtl') === 'true') {
      varDirection = 'rtl';
    } else {
      varDirection = 'ltr';
    }
    const modalRef = this.modalService.open(FormDialogComponent, {
      size: 'xl',
      windowClass: 'modal-xxl',
      centered: true,
    });
    modalRef.componentInstance.data = { item: data, action };
    modalRef.closed.subscribe((result) => {
      console.log('result: ', result);
      // if (result && result.id) this.onSearchClient(result.id);
    });
  }
  openAddApporteurModal(action: 'add' | 'edit', data?: any) {
    let varDirection: Direction;
    if (localStorage.getItem('isRtl') === 'true') {
      varDirection = 'rtl';
    } else {
      varDirection = 'ltr';
    }
    const modalRef = this.modalService.open(ModalAddApporteur, {
      size: 'xl',
      windowClass: 'modal-xxl',
      centered: true,
    });
    modalRef.componentInstance.data = { item: data, action };
    modalRef.componentInstance.closed.subscribe(() => modalRef.dismiss());
    modalRef.closed.subscribe((result) => {
      console.log('result: ', result);
      if (result && result.id) this.onSearchApporteur(result.id);
    });
  }

  onSearchApporteur(apporteur_id?: any) {
    // if(!this.client_search_key) return
    let request = {
      search_key: this.apporteur_search_key,
      data: {
        // telephone:this.client_search_key
        id: apporteur_id,
      },
      index: 0,
      size: 10000,
    };

    this.restClient.post('apporteur/getByCriteria', request).subscribe(
      (res: any) => {
        if (res && res['items'] && !res['hasError']) {
          this.itemsApporteur = res['items'];
          if (apporteur_id) this.itemToSave.apporteur_id = apporteur_id;
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center'
          );
          this.itemsApporteur = [];
        }
      },
      (err) => {
        this.itemsApporteur = [];
      }
    );
  }
  // ─── Vente directe boutique ───────────────────────────────────────────────

  get filteredArticles(): any[] {
    if (!this.article_search) return this.itemsArticle;
    const key = this.article_search.toLowerCase();
    return this.itemsArticle.filter((a: any) =>
      a.libelle?.toLowerCase().includes(key)
    );
  }

  get cartTotal(): number {
    return this.itemsCommandeDetailToSave.reduce(
      (sum: number, i: any) => sum + (i.total || 0),
      0
    );
  }

  isInCart(article: any): boolean {
    return this.itemsCommandeDetailToSave.some(
      (d: any) => d.article_id === article.id
    );
  }

  getCartQty(article: any): number {
    const item = this.itemsCommandeDetailToSave.find(
      (d: any) => d.article_id === article.id
    );
    return item ? item.quantite : 0;
  }

  addToCart(article: any) {
    const existing = this.itemsCommandeDetailToSave.find(
      (d: any) => d.article_id === article.id
    );
    if (existing) {
      if (existing.quantite >= article.quantite_en_stock) {
        this.utilities.showNotification(
          'snackbar-danger',
          'Stock max : ' + article.quantite_en_stock,
          'bottom',
          'center'
        );
        return;
      }
      existing.quantite += 1;
      existing.total = existing.quantite * existing.prix;
    } else {
      if (article.quantite_en_stock <= 0) {
        this.utilities.showNotification(
          'snackbar-danger',
          'Stock insuffisant',
          'bottom',
          'center'
        );
        return;
      }
      this.itemsCommandeDetailToSave.unshift({
        article_id: article.id,
        article_libelle: article.libelle,
        prix: article.prix_vente,
        quantite: 1,
        total: article.prix_vente,
      });
    }
  }

  removeFromCart(index: number) {
    this.itemsCommandeDetailToSave.splice(index, 1);
  }

  onCartQtyChange(item: any, index: number) {
    if (item.quantite <= 0) {
      this.itemsCommandeDetailToSave.splice(index, 1);
      return;
    }
    const article = this.itemsArticle.find(
      (a: any) => a.id === item.article_id
    );
    if (article && item.quantite > article.quantite_en_stock) {
      item.quantite = article.quantite_en_stock;
    }
    item.total = item.quantite * item.prix;
  }

  saveVenteDirecteCommande(hebergement: any, onDone: () => void) {
    const details = this.itemsCommandeDetailToSave.map((d: any) => ({
      ...d,
      type_commande_id: this.venteDirecteTypeCommandeId,
      hebergement_id: hebergement.id,
      chambre_id: hebergement.chambre_id,
      client_id: hebergement.client_id,
    }));

    const montant = details.reduce(
      (s: number, d: any) => s + (d.total || 0),
      0
    );
    const commande: any = {
      code: this.generateUniqueString(),
      type_commande_id: this.venteDirecteTypeCommandeId,
      client_id: hebergement.client_id,
      hebergement_id: hebergement.id,
      chambre_id: hebergement.chambre_id,
      commandeDetail: details,
      quantite: details.reduce((s: number, d: any) => s + (d.quantite || 0), 0),
      montant,
      nombre: details.length,
      is_validated: true,
      is_vente_directe: true,
      is_client: true,
      groupe_id: this.user.groupe_id,
      hotel_id: this.user.hotel_id,
    };

    this.restClient.post('commande/create', { datas: [commande] }).subscribe({
      next: (res: any) => {
        if (!res['hasError']) {
          this.loadCommandeDetailForLivraison(res['item'], hebergement, onDone);
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center'
          );
          onDone();
        }
      },
      error: () => {
        this.utilities.showNotification(
          'snackbar-danger',
          this.utilities.getMessageEndPointNotAvailble(),
          'bottom',
          'center'
        );
        onDone();
      },
    });
  }

  loadCommandeDetailForLivraison(
    commande: any,
    hebergement: any,
    onDone: () => void
  ) {
    this.restClient
      .post('commandeDetail/getByCriteria', {
        type_commande_codification: 'BOUTIQUE',
        data: { commande_id: commande.id },
        index: 0,
        size: 10000,
      })
      .subscribe({
        next: (res: any) => {
          if (!res['hasError'] && res['items']) {
            let totalMontant = 0;
            const livraisonDetails = res['items'].map((d: any) => {
              const m = Number(d.montant) || 0;
              totalMontant += m;
              return {
                ...d,
                quantite_commande: d.quantite,
                prix_unitaire: d.prix,
                montant_commande: d.montant,
                quantite_livraison: d.quantite,
                montant_livraison: m,
                is_checked: true,
                // Sans magasin : l'API prélève sur les magasins qui ont l'article en stock.
                magasin_id: null,
                mode_livraison: 'SORTIE',
              };
            });
            this.saveLivraisonVenteDirecte(
              commande,
              livraisonDetails,
              totalMontant,
              hebergement,
              onDone
            );
          } else {
            onDone();
          }
        },
        error: () => onDone(),
      });
  }

  saveLivraisonVenteDirecte(
    commande: any,
    details: any[],
    montant: number,
    hebergement: any,
    onDone: () => void
  ) {
    const livraison: any = {
      code: this.generateUniqueString(),
      commande_id: commande.id,
      client_id: commande.client_id,
      type_commande_id: commande.type_commande_id,
      hebergement_id: commande.hebergement_id,
      magasin_id: null,
      livraisonDetail: details,
      quantite_commande: details.reduce(
        (s: number, d: any) => s + (Number(d.quantite_commande) || 0),
        0
      ),
      montant_commande: montant,
      montant_livraison: montant,
      quantite_livraison: details.reduce(
        (s: number, d: any) => s + (Number(d.quantite_livraison) || 0),
        0
      ),
      montant,
      is_ristourne: false,
      is_validated: true,
      is_vente_directe: true,
      mode_livraison: 'SORTIE',
      groupe_id: this.user.groupe_id,
      hotel_id: this.user.hotel_id,
    };

    this.restClient.post('livraison/create', { datas: [livraison] }).subscribe({
      next: (res: any) => {
        if (!res['hasError']) {
          this.utilities.showNotification(
            'snackbar-success',
            'Vente directe enregistrée avec succès',
            'bottom',
            'center'
          );
          onDone();
          this.showReceiptsPopup(hebergement, commande, res['item']);
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center'
          );
          onDone();
        }
      },
      error: () => {
        this.utilities.showNotification(
          'snackbar-danger',
          this.utilities.getMessageEndPointNotAvailble(),
          'bottom',
          'center'
        );
        onDone();
      },
    });
  }

  showReceiptsPopup(hebergement: any, commande: any, livraison: any) {
    Swal.fire({
      title: 'Reçus disponibles',
      html: `
        <div style="display:flex; flex-direction:column; gap:10px; margin-top:8px;">
          <button id="btn-recu-heb" class="swal2-confirm swal2-styled" style="background:#0665aa; justify-content:center;">
            🏨 Reçu Hébergement
          </button>
          <button id="btn-recu-cmd" class="swal2-confirm swal2-styled" style="background:#5c2d91; justify-content:center;">
            🛍️ Reçu Commande boutique
          </button>
          <button id="btn-recu-liv" class="swal2-confirm swal2-styled" style="background:#198754; justify-content:center;">
            📦 Reçu Livraison
          </button>
        </div>`,
      showConfirmButton: false,
      showCloseButton: true,
      didOpen: () => {
        document
          .getElementById('btn-recu-heb')
          ?.addEventListener('click', () =>
            this.printRecuHebergement(hebergement)
          );
        document
          .getElementById('btn-recu-cmd')
          ?.addEventListener('click', () => this.printRecuCommande(commande));
        document
          .getElementById('btn-recu-liv')
          ?.addEventListener('click', () => this.printRecuLivraison(livraison));
      },
    });
  }

  printRecuHebergement(hebergement: any) {
    this.restClient
      .post('reglementHebergement/getByCriteria', {
        data: { hebergement_id: hebergement.id },
        index: 0,
        size: 1,
      })
      .subscribe((res: any) => {
        if (!res['hasError'] && res['items']?.length) {
          this.restClient
            .post('pdf/printRecuHebergement', {
              data: { id: res['items'][0].id },
              index: 0,
              size: 1,
            })
            .subscribe((r: any) => {
              if (!r['hasError'] && r['item']?.link)
                window.open(r['item'].link, '_blank');
            });
        }
      });
  }

  printRecuCommande(commande: any) {
    this.restClient
      .post('pdf/printRecuCommande', {
        data: { id: commande.id, entite: 'BOUTIQUE' },
        index: 0,
        size: 1,
      })
      .subscribe((res: any) => {
        if (!res['hasError'] && res['item']?.link)
          window.open(res['item'].link, '_blank');
      });
  }

  printRecuLivraison(livraison: any) {
    this.restClient
      .post('reglementAutre/getByCriteria', {
        data: { livraison_id: livraison.id },
        index: 0,
        size: 1,
      })
      .subscribe((res: any) => {
        if (!res['hasError'] && res['items']?.length) {
          this.restClient
            .post('pdf/printRecuAutre', {
              data: { id: res['items'][0].id, entite: 'BOUTIQUE' },
              index: 0,
              size: 1,
            })
            .subscribe((r: any) => {
              if (!r['hasError'] && r['item']?.link)
                window.open(r['item'].link, '_blank');
            });
        }
      });
  }

  getItemsArticle() {
    this.restClient
      .post('article/getByCriteria', {
        is_for_commande_boutique: true,
        add_stock_info: true,
        data: {},
        index: 0,
        size: 10000,
      })
      .subscribe((res: any) => {
        if (!res['hasError'] && res['items']) {
          this.itemsArticle = res['items'];
        }
      });
  }

  getItemsTypeCommandeBoutique() {
    this.restClient
      .post('typeCommande/getByCriteria', {
        data: { codification: 'BOUTIQUE' },
        index: 0,
        size: 10000,
      })
      .subscribe((res: any) => {
        if (!res['hasError'] && res['items'] && res['items'].length) {
          this.venteDirecteTypeCommandeId = res['items'][0].id;
        }
      });
  }

  generateUniqueString() {
    var timestamp = new Date().getTime();
    var randomNumber = Math.floor(Math.random() * 1000000);

    var uniqueString = timestamp.toString() + randomNumber.toString();
    return uniqueString;
  }
  capitalize(str: any) {
    return str.replace(/^\w/, (c: string) => c.toUpperCase());
  }

  onClientChange(client: any) {
    this.clientFidelite = client?.fidelite ?? null;
  }

  canUseFidelity(): boolean {
    if (!this.clientFidelite) return false;
    return (this.clientFidelite.montant_equivalent ?? 0) >= (this.itemToSave.montant_avance ?? 0);
  }

  onCalculateMonnaie() {
    // debugger
    if (this.itemToSave.client_idFileAttente) {
      if (
        this.itemToSave.montant_restant_file_attente > 0 &&
        this.itemToSave.montant_recu > 0 &&
        this.itemToSave.montant_recu >
          this.itemToSave.montant_restant_file_attente
      ) {
        this.itemToSave.monnaie_rendue =
          this.itemToSave.montant_recu -
          this.itemToSave.montant_restant_file_attente;
      }
      if (
        this.itemToSave.montant_restant_file_attente >
        this.itemToSave.montant_recu
      ) {
        // this.itemToSave.montant_recu = this.itemToSave.montant_restant_file_attente
        this.itemToSave.monnaie_rendue = 0;
      }
    } else {
      if (
        this.itemToSave.montant_avance > 0 &&
        this.itemToSave.montant_recu > 0 &&
        this.itemToSave.montant_recu > this.itemToSave.montant_avance
      ) {
        this.itemToSave.monnaie_rendue =
          this.itemToSave.montant_recu - this.itemToSave.montant_avance;
      }
      if (this.itemToSave.montant_avance > this.itemToSave.montant_recu) {
        // this.itemToSave.montant_recu = this.itemToSave.montant_avance
        this.itemToSave.monnaie_rendue = 0;
      }
    }
  }

  // getItemsService() {
  //   this.itemsChambre = []
  //   let request = {
  //     data: {
  //     },
  //     index: 0,
  //     size: 10000,
  //   };

  //   this.restClient
  //     .post("service/getByCriteria", request)
  //     .subscribe(
  //       (res: any) => {
  //         if (res && res["items"] && !res['hasError']) {
  //           this.itemsService = res["items"];

  //         } else {
  //           this.utilities.showNotification(
  //             "snackbar-danger",
  //             this.utilities.formatMsgServeur(res["status"]["message"]),
  //             "bottom",
  //             "center"
  //           );
  //           this.itemsService = [];
  //         }
  //       },
  //       (err) => {
  //         this.itemsService = [];

  //       }
  //     );
  // }

  getItemsService() {
    this.itemsChambre = [];
    let request = {
      data: {},
      index: 0,
      size: 10000,
    };

    this.restClient.post('service/getByCriteria', request).subscribe({
      next: (res: any) => {
        if (res && res['items'] && !res['hasError']) {
          const allServices = res['items'];
          const now = moment();

          this.itemsService = allServices.filter((service: any) => {
            const start = service.periodicite_heure_debut;
            const end = service.periodicite_heure_fin;

            // Eligible by default if no time range
            if (!start || !end) return true;

            // Today’s date for start
            let startTime = moment(start, 'HH:mm:ss');
            let endTime = moment(end, 'HH:mm:ss');

            // If overnight (end < start), endTime belongs to next day
            if (endTime.isBefore(startTime)) {
              endTime.add(1, 'day');
            }

            // Check if current time is in interval
            return now.isBetween(startTime, endTime);
          });
          console.log(
            'this.itemToSave.type_service_codification: ',
            this.itemToSave.type_service_codification
          );
          console.log('this.itemsService: ', this.itemsService);
          if (this.itemToSave.type_service_codification) {
            let result = this.itemsService.find(
              (is: any) =>
                is.codification == this.itemToSave.type_service_codification
            );
            this.itemToSave.service_id = result ? result.id : '';
            if (this.itemToSave.service_id) {
              this.onSelectService();
            }
          }
          console.log('Eligible services:', this.itemsService);
          this.onSelectService();
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center'
          );
          this.itemsService = [];
        }
      },
      error: (err) => {
        console.error('Erreur lors de la récupération des services :', err);
        this.itemsService = [];
      },
    });
  }

  onSelectDateDebut(event: any) {
    this.itemToSave.date_debut = event;
    this.itemToSave.montant_total = 0;
    this.onGetChambreDisponible();
  }
  onSelectDateFin(event: any) {
    this.itemToSave.date_fin = event;
    this.itemToSave.montant_total = 0;
    this.onGetChambreDisponible();
  }

  getItemsTypeHebergement() {
    this.itemsChambre = [];
    let request = {
      data: {},
      index: 0,
      size: 10000,
    };

    this.restClient.post('typeHebergement/getByCriteria', request).subscribe({
      next: (res: any) => {
        if (res && res['items'] && !res['hasError']) {
          this.itemsTypeHebergement = res['items'];
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center'
          );
          this.itemsTypeHebergement = [];
        }
      },
      error: () => {
        this.itemsTypeHebergement = [];
      },
    });
  }

  getitemsFileAttente() {
    let request = {
      add_caisse_status: true,
      order_by: 'created_at',
      date_debut: this.date_debut,
      date_fin: this.date_fin,
      data: {
        // user_id: this.user.id,
        hotel_id: this.user.hotel_id,
      },
      index: 0,
      size: 10000,
    };

    this.restClient
      .post('fileAttenteHebergement/getByCriteria', request)
      .subscribe({
        next: (res: any) => {
          if (res && res['items'] && !res['hasError']) {
            this.itemsFileAttenteHebergement = res['items'];

            // remove cancelled
            this.itemsFileAttenteHebergement =
              this.itemsFileAttenteHebergement.filter(
                (ifah: any) => !ifah.is_cancelled
              );
            // remove affected
            this.itemsFileAttenteHebergement =
              this.itemsFileAttenteHebergement.filter(
                (ifah: any) => !ifah.is_affected
              );

            // get today's date
            const today = new Date();

            // format to YYYY-MM-DD for comparison
            const todayStr = today.toISOString().split('T')[0];

            this.itemsFileAttenteHebergement =
              this.itemsFileAttenteHebergement.filter((item: any) => {
                const dateStr = new Date(item.created_at)
                  .toISOString()
                  .split('T')[0];
                return dateStr === todayStr;
              });

            // this.itemsFileAttenteHebergement = this.itemsFileAttenteHebergement.filter((ic:any)=>ic.is_open)
            this.queueCount = this.itemsFileAttenteHebergement.length;
            // console.log('itemsFileAttenteHebergement: ',this.itemsFileAttenteHebergement)
          } else {
            this.utilities.showNotification(
              'snackbar-danger',
              this.utilities.formatMsgServeur(res['status']['message']),
              'bottom',
              'center'
            );
            this.itemsFileAttenteHebergement = [];
          }
        },
        error: () => {
          this.itemsFileAttenteHebergement = [];
        },
      });
  }

  onSelectFileAttente() {
    if (this.itemToSave.client_idFileAttente) {
      const selected_file_attente = this.itemsFileAttenteHebergement.find(
        (ifh: any) => ifh.id == this.itemToSave.client_idFileAttente
      );
      console.log('selected_file_attente: ', selected_file_attente);
      if (!selected_file_attente) return;
      this.itemToSave.client_id = selected_file_attente.client_id;
      this.itemToSave.file_attente_hebergement_id =
        this.itemToSave.client_idFileAttente;
      this.itemToSave.montant_avance_file_attente =
        selected_file_attente.montant_avance;
      this.itemToSave.montant_restant_file_attente =
        this.itemToSave.montant_total - selected_file_attente.montant_avance;
      this.itemToSave.montant_ristourne_file_attente =
        this.itemToSave.montant_restant_file_attente < 0
          ? -this.itemToSave.montant_restant_file_attente
          : 0;
      this.itemToSave.montant_restant_file_attente =
        this.itemToSave.montant_restant_file_attente > 0
          ? this.itemToSave.montant_restant_file_attente
          : 0;
    } else {
      this.itemToSave.client_id = '';
      this.itemToSave.file_attente_hebergement_id = '';
      this.itemToSave.montant_avance_file_attente = '';
      this.itemToSave.montant_restant_file_attente = '';
      this.itemToSave.montant_ristourne_file_attente = '';
      this.itemToSave.montant_restant_file_attente = '';
    }
  }
}
